import { Tab, TabProps } from "@mui/material";
import { useTabButtonsStyles } from "./useTabButtonsStyles";

export const TabButton = ({ ...restProps }: TabProps): JSX.Element => {
  const { classes } = useTabButtonsStyles();

  return <Tab {...restProps} className={classes.tab} />;
};
